<template>
  <div v-if="content" :style="`background-image:url(${content.img})`" class="page-header">
    <div class="bg"></div>
    <img v-if="content.picto" class="picto" :src="content.picto">
    <custom-title :content="content" class="title"></custom-title>
  </div>
</template>

<script>
export default {
  props: {
    content: null
  }
};
</script>

<style lang="scss">
.page-header {
  width: 100%;
  height: 500px;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  clip-path: ellipse(100% 66% at 50% 34%);
  padding-bottom: 1.5em;

  .picto {
    max-width: 130px;
    max-height: 130px;
    height: auto;
    z-index: 2;
  }
  .bg {
    position: absolute;

    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
  .title {
    position: relative;
    z-index: 1;
    padding: 0.2em 0;
    color: #fff;
    font-size: 40px;
    text-shadow: -1px -1px 0 rgba(0, 0, 0, 0.8),
      -2px -2px 1px rgba(0, 0, 0, 0.8);
      white-space: pre-wrap;
  }
}

@media screen and (max-width:800px) {
  .page-header {
    height:250px;
    .picto {
      max-width:80px;
      max-height:80px;
    }
    .title {
      font-size:30px;
    }
  }
}
</style>
